"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const loyaltyWrapperInputs = [
  {
    name: "name",
    type: "string",
    required: true,
    enum: [
      {
        label: "General",
        value: "general",
      },
      {
        label: "Account",
        value: "account",
      },
    ],
    defaultValue: "general",
  },
  {
    name: "hideMyAddress",
    type: "boolean",
    defaultValue: false,
    showIf: `options.get("variant") === "account"`,
    helperText: "Hide the address section in the account page",
  },
] as const satisfies Inputs;

export const LoyaltyWrapperComponent: RegisteredComponent = {
  name: "LoyaltyWrapper",
  component: dynamic(async () => (await import("./LoyaltyWrapper")).LoyaltyWrapper),
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  inputs: loyaltyWrapperInputs,
};
